module.exports = __webpack_public_path__ + "img/6S.c99b0f04.png";